import { useEffect, useRef } from 'react';

type Handler = () => void;

const useClickOutside = <T extends HTMLElement>(handler: Handler) => {
  const ref = useRef<T | null>(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (ref.current && !ref.current.contains(event.target as Node)) {
      handler();
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [handler]);

  return ref;
};

interface ComponentWithClickOutsideProps {
  children: React.ReactNode;
  onOutsideClick: Handler;
}

export const ComponentWithClickOutside: React.FC<ComponentWithClickOutsideProps> = ({ children, onOutsideClick }) => {
  const clickRef = useClickOutside<HTMLDivElement>(onOutsideClick);

  return <div ref={clickRef}>{children}</div>;
};
